import React, { useEffect } from "react";
import DataGrid from "@common/components/shared/DataGrid";
import useLinkedSession from "@common/components/hooks/useLinkedSession";
import LinkSessionAction from "@common/redux/actions/LinkSessionAction";
import ButtonComponent from "../forms/ButtonComponent";
import {
  handleOptionChange,
  handleRowClickOptionChange,
} from "../../helpers/Sessions/sessionsDetailsHelpers";
import SuspiciousActivityAction from "@common/redux/actions/SuspiciousActivityAction";
import { useSelector } from "react-redux";

const LinkedSession = () => {
  const {
    control,
    details,
    linkedSessionData,
    sessionsToBeDeleted,
    linkedAlertData,
    confirmRemoveSessions,
    setMachine,
  } = useLinkedSession();
  const { formData } = useSelector((state) =>
    SuspiciousActivityAction.getStatePath(state),
  );

  // This is for Suspicious Activity
  useEffect(() => {
    if (formData?.machine?.installationId) {
      setMachine({
        installationId: formData?.machine?.installationId?.toString(),
      });
    }
  }, [details.machineInstallationId]);

  return (
    <>
      <p>
        <b>{details?.title ?? ""}</b>
      </p>
      {linkedSessionData.length > 0 ? (
        <DataGrid
          className="h-15"
          headings={details.grid.headerDef}
          data={linkedSessionData}
          rowDef={details.grid.rowDef}
          onRowClick={(row) => {
            const newGridData = handleRowClickOptionChange(
              linkedSessionData,
              row,
            );
            LinkSessionAction.onOptionChange(newGridData);
          }}
          onOptionChange={(event, rowIndex, option) => {
            const newGridData = handleOptionChange(
              event,
              linkedSessionData,
              rowIndex,
              option,
            );
            LinkSessionAction.onOptionChange(newGridData);
          }}
        />
      ) : (
        <></>
      )}
      {sessionsToBeDeleted.length > 0 ? (
        <ButtonComponent
          control={control}
          name="removeLinkedSession"
          buttonName="Remove selected session"
          fieldStyle="pt-1"
          handleClick={() =>
            confirmRemoveSessions(sessionsToBeDeleted, linkedAlertData)
          }
        />
      ) : (
        <></>
      )}
      <br />
    </>
  );
};

export default LinkedSession;
